// reducer
import { initialState } from "@/store/MyClients/state";

export const allClientsMutation = (state, data) => {
  // Vue.set(state.MyClients, "myClients", data);
  // state.MyClients.myClients = data;

  state.MyClients.myClients.list = [
    ...state.MyClients.myClients.list,
    ...data.list
  ];

  state.MyClients.myClients.pagination = data.pagination;
};

export const resetMyClients = state => {
  state.MyClients.myClients = initialState().myClients;
};
